// extracted by mini-css-extract-plugin
module.exports = {"hide-scrollbar":"AlliedServices_hide-scrollbar__pPQtg","allied-services-section":"AlliedServices_allied-services-section__EhbmX"};